import React from "react";
import { Theme } from "@material-ui/core";
import Container from "@material-ui/core/Container";
import Loading from "../../../../components/Loading";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { AdapterLink } from "../../../../components/Adopter";
import { useQuery } from "react-query";
import Button from "../../../../components/Button";
import useDegreeQueries from "../../hooks/useDegreeQueries";
import Error from "../../../../components/Error";
import { mutateErrors } from "../../../../utils";
import PageHeader from "../../../../components/PageHeader";
import { Routes } from "../../../../constants/routes";
import Grid from "@material-ui/core/Grid";
import DegreeListItem from "../../components/DegreeListItem";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
  },
}));

export default function ListPage() {
  const classes = useStyles();
  const { fetchAll } = useDegreeQueries();
  const { isLoading, isFetching, isError, error, refetch, data } =
    useQuery<any>("degrees", fetchAll);

  if (isLoading || isFetching) {
    return <Loading />;
  }

  if (isError) {
    const { message } = mutateErrors(error);
    return <Error text={message} />;
  }

  return (
    <>
      <Container maxWidth="lg">
        <PageHeader
          title={"Degrees"}
          subtitle={"Here are listed program degrees"}
          endAdornment={
            <Button
              color={"success"}
              variant={"contained"}
              component={AdapterLink}
              to={`/0/${Routes.DEGREES}/create`}
            >
              Add
            </Button>
          }
        />
      </Container>

      <Container maxWidth="lg" className={classes.container}>
        <Grid container spacing={2}>
          {data &&
            data.data.map((degree: any, index) => (
              <DegreeListItem
                onDelete={refetch}
                index={index}
                degree={degree}
                key={`DegreeListItem_${index}`}
              />
            ))}
        </Grid>
      </Container>
    </>
  );
}
